import React, { useRef, useState, useContext } from 'react'
import { useReactToPrint } from 'react-to-print'
import { Dialog, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core'
import { CardBody } from 'components/common/Card'
import 'assets/css/PrintBOLModal.css'
import { createDateString } from 'helpers'
import LetterBOL from './LetterBOL'
import ThermalBOL from './ThermalBOL'
import LetterBOLCement from './LetterBOLCement'
import ThermalBOLCement from './ThermalBOLCement'
import LetterBOLEthanol from './LetterBOLEthanol'
import ThermalBOLEthanol from './ThermalBOLEthanol'
import { ReducerContext } from 'App'
import { BOL_TEMPLATE_SAND, BOL_TEMPLATE_CEMENT, BOL_TEMPLATE_ETHANOL, getBolTemplate } from 'constants/productTypes'

// Template components mapped by bol_template and print format
const TEMPLATE_MAP = {
  [BOL_TEMPLATE_SAND]: { letter: LetterBOL, thermal: ThermalBOL },
  [BOL_TEMPLATE_CEMENT]: { letter: LetterBOLCement, thermal: ThermalBOLCement },
  [BOL_TEMPLATE_ETHANOL]: { letter: LetterBOLEthanol, thermal: ThermalBOLEthanol }
}

const BOLPrint = ({
  bolData: {
    bolId,
    gross_weight,
    tare_weight,
    processed_at,
    terminal,
    buyer,
    purchase_order_number,
    sand_type,
    supplier,
    bol_template
  },
  bolData,
  handleClose,
  open,
  specificInvInterData: { invInters }
}) => {
  const componentRef = useRef()

  const {
    state: { currentTerminal }
  } = useContext(ReducerContext)

  const [printFormat, setPrintFormat] = useState(currentTerminal === 'Wyalusing' ? 'thermal' : 'letter')
  const printClickHandler = useReactToPrint({ content: () => componentRef.current })

  // Select template based on bol_template field, or derive from sand_type
  const templateType = bol_template || getBolTemplate(sand_type)
  const BOLComponent = TEMPLATE_MAP[templateType]?.[printFormat] || TEMPLATE_MAP[BOL_TEMPLATE_SAND][printFormat]

  // Check if this is an ethanol BOL (volume-based)
  const isEthanol = templateType === BOL_TEMPLATE_ETHANOL

  const date = new Date(processed_at).toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })

  const bolQR = {
    'Ticket No': `${bolId}`,
    Customer: buyer,
    'PO #': purchase_order_number,
    Product: sand_type,
    Gross: `${gross_weight}`,
    Net: `${gross_weight - tare_weight}`,
    Tare: `${tare_weight}`,
    Date: createDateString(processed_at),
    Vendor: supplier,
    Facility: terminal
  }

  // For weight-based BOLs (sand, cement): total = last gross - tare
  // For volume-based BOLs (ethanol): totalVolume = last volume_reading (cumulative gallons)
  const total = invInters[invInters.length - 1].gross_weight - tare_weight
  const totalVolume = isEthanol && invInters.length > 0 ? Number(invInters[invInters.length - 1].volume_reading) || 0 : 0

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md">
        <CardBody className="">
          <div className="print-controls hide-on-print">
            <button className="hide-on-print" id="printButton" onClick={printClickHandler}>
              Print BOL #{bolId}
            </button>
            <FormControl variant="outlined" style={{ minWidth: 200, marginRight: 16 }}>
              <InputLabel>Print Format</InputLabel>
              <Select value={printFormat} onChange={e => setPrintFormat(e.target.value)} label="Print Format">
                <MenuItem value="letter">Letter Size</MenuItem>
                <MenuItem value="thermal">Thermal (3.15" wide)</MenuItem>
              </Select>
            </FormControl>
          </div>
          <BOLComponent {...{ date, bolQR, total, totalVolume, bolData, componentRef, invInters }} />
        </CardBody>
      </Dialog>
    </div>
  )
}

export default BOLPrint
